export function renderBuildSortableHeaderButtonJsxActionButtonsTemplate({
  className,
  escapeTemplateText,
  escapeJsx
}: {
  className: string
  escapeTemplateText: string
  escapeJsx: string
}): string {
  return `<Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
          className="${className} min-w-0 justify-start overflow-hidden px-0! border-none rounded-none bg-transparent! scale-100! group"
          aria-label={\`Sort by ${escapeTemplateText}, \${sortLabel}\`}
          aria-sort={sortDirection === 'asc' ? 'ascending' : sortDirection === 'desc' ? 'descending' : 'none'}
        >
          <span className="truncate">${escapeJsx}</span>
          <SortIndicator direction={sortDirection} />
        </Button>`
}
